module.exports = __webpack_public_path__ + "static/media/pause.aa88967d.svg";